import { deepFreeze } from "@/utils/structure";

export const CRISP_CHATBOT_FIRST_NAME = "Gracie";
export const CRISP_CHATBOT_LAST_NAME = "Chatbot";
export const CRISP_CHATBOT_IDENTIFIER =
  process.env.CRISP_CHATBOT_IDENTIFIER || "";
export const CRISP_CHATBOT_KEY = process.env.CRISP_CHATBOT_KEY || "";
export const CRISP_CHATBOT_SECRET = process.env.CRISP_CHATBOT_SECRET || "";
export const CRISP_CHATBOT_USER_ID = process.env.CRISP_CHATBOT_USER_ID || "";
export const DEFAULT_OPERATOR_EMAIL = "hello@justship.sg";
export const CRISP_BASE_URL = "https://api.crisp.chat/v1";
export const MAX_QUESTION_LENGTH = 1500;
export const MAX_PICKER_CHOICES = 10;
export const ENABLE_GRACIE_SCREENING_FLOW =
  process.env.ENABLE_GRACIE_SCREENING_FLOW === "1" || false;

export const CRISP_WEBSITE_ID = process.env.CRISP_WEBSITE_ID || "";
export const NEXT_PUBLIC_CRISP_WEBSITE_ID =
  process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID || "";
export const CRISP_WEBSITE_SECRET_KEY =
  process.env.CRISP_WEBSITE_SECRET_KEY || "";
export const SHOW_CRISP_WIDGET =
  process.env.NEXT_PUBLIC_SHOW_CRISP_WIDGET === "1" || false;

export const CRISP_WHATSAPP_BUSINESS_IDENTIFIER =
  process.env.CRISP_WHATSAPP_BUSINESS_IDENTIFIER || "";
export const CRISP_WHATSAPP_BUSINESS_KEY =
  process.env.CRISP_WHATSAPP_BUSINESS_KEY || "";
export const CRISP_WHATSAPP_FROM_NUMBER =
  process.env.CRISP_WHATSAPP_FROM_NUMBER || "";
export const CRISP_WHATSAPP_BASE_URL =
  "https://plugins.crisp.chat/urn:crisp.im:whatsapp:0/wa/api";
export const CRISP_INBOX_BASE_URL = `https://app.crisp.chat/website/${CRISP_WEBSITE_ID}/inbox`;

export const CRISP_WHATSAPP_BUSINESS_REQUEST_TYPE = Object.freeze({
  TOPUP_REQUEST: "Top Up Request",
  PICKUP_ETA_INITIAL: "Pickup ETA Initial",
  REFUND_NOTICE: "Refund Notice",
  REVIEW_REQUEST_GOOGLE: "Review Request Google",
  REVIEW_REQUEST_FACEBOOK: "Review Request Facebook",
});

export const WHATSAPP_BUSINESS_TEMPLATES = Object.freeze({
  TOPUP_REQUEST: "topup_with_user_acc_v2",
  PICKUP_ETA_INITIAL_GENERAL: "pickup_eta_v4",
  PICKUP_ETA_INITIAL_ECOMMERCE: "pickup_eta_ecommerce_v1",
  REFUND_NOTICE: "refund_original_method",
  PICKUP_MOQ_SURCHARGE_REFUND_NOTICE: "refund_pickup_moq_surcharge",
  REVIEW_REQUEST_GOOGLE: "delivery_status_review",
  REVIEW_REQUEST_FACEBOOK: "delivered_review_fb",
});

// Sessions IDs of internal users
export const WHITELIST_SESSION_IDS = deepFreeze([
  "session_a3b4083a-15b6-43d0-9da3-370080b7abac", // Trix - whatsapp
  "session_5fbc0b59-775f-4ffb-ae5e-36f9a317747e", // Trix - chat
  "session_304c30a8-bc4a-4b50-9784-2d5237a3d062", // Sherman - whatsapp
  "session_2537e7a3-512d-49bb-b08c-2e76cb96a349", // Sherman - chat
  "session_f122c809-e274-432f-8acd-0b26ad8ce9a2", // Shi Ping - whatsapp
  "session_953c6620-d6e4-4a1c-abfa-55fd64f48903", // Shi Ping - chat
  "session_5eba214b-89da-4460-bf70-8e72e1bc399b", // Shannon - whatsapp
  "session_636f7881-d8c9-47c2-9132-6090bf5489cf", // Shannon - chat
  "session_88dabe94-83c7-49a6-aa84-e781895c27f0", // Son - whatsapp
  "session_0fd2d9cd-959a-4d7d-a921-a105ff6852fa", // Son - chat
  "session_cfe9beaf-4219-4914-be05-a16fd53322b4", // Fanny - whatsapp
  "session_0adda7ff-90bc-416a-b11e-417bac87ab89", // Fanny - chat
]);

export const SLEEP_MS_BEFORE_REPLY = 4 * 1000;

export const CRISP_MESSAGE_PLATFORMS = deepFreeze({
  whatsapp: "whatsapp",
  chat: "chat",
});

export const CRISP_CONVERSATION_STATES = deepFreeze({
  STARTED: {
    label: "Started", // Gracie has not sent the template hello message
    value: "started",
  },
  PENDING_QUESTION_TYPE: {
    label: "Pending question type", // Gracie has sent the hello message. Waiting for user reply.
    value: "pending_question_type",
  },
  PENDING_SHIPPING_ID_FOR_ORDER_QUESTION: {
    label: "Pending shippingID for order question", // User selects/types order-related question
    value: "pending_shipping_id_for_order_question",
  },
  PENDING_SELECTED_SHIPPING_ID_FOR_ORDER_QUESTION: {
    label: "Pending selected shippingID for order question", // User picks a shipment among multiple shipments in an order.
    value: "pending_selected_shipping_id_for_order_question",
  },
  PENDING_USER_SEGMENT_FOR_GENERAL_QUESTION: {
    label: "Pending user segment for general question", // User selects general question
    value: "pending_user_segment_for_general_question",
  },
  ESCALATED: {
    // Shipment found. An escalated message has been sent and widget conversation is resolved.
    label: "Escalated",
    value: "escalated",
  },
  ASSIGNED_TO_CHATBOT: {
    // Gracie replies to messages
    label: "Assigned to chatbot",
    value: "assigned_to_chatbot",
  },
  ASSIGNED_TO_OPERATOR: {
    // Operator replies on Crisp platform
    label: "Assigned to operator",
    value: "assigned_to_operator",
  },
  RESOLVED: {
    label: "Resolved",
    value: "resolved",
  },

  // Assign to existing conversations before the new flow.
  UNSUPPORTED: {
    label: "Unsupported",
    value: "unsupported",
  },
});

export const CRISP_CONVERSATION_STATES_CHATBOT_DO_NOT_REPLY = deepFreeze([
  CRISP_CONVERSATION_STATES.ESCALATED.value,
  CRISP_CONVERSATION_STATES.ASSIGNED_TO_OPERATOR.value,
]);

export const USER_QUESTION_TYPES = deepFreeze({
  GENERAL_QUESTION: {
    label: "General Question",
    value: "general_question",
  },
  SHIPMENT_RELATED_QUESTION: {
    label: "Shipment Related Question",
    value: "shipment_related_question",
  },
});

export const CRISP_INBOXES = deepFreeze({
  MAIN_INBOX_ID: null,
  SALES_ECOMMERCE_INBOX_ID: "82750c1a-57b1-4f62-b38e-7f8775043577",
  SALES_RELOCATOR_INBOX_ID: "ce739095-d549-4ccb-9774-a1a08d983ac8",
  SALES_CORPORATE_INBOX_ID: "1ddce57c-7af9-4c38-82cd-aab0981eca31",
  SALES_EVERYONE_INBOX_ID: "970796fd-d938-42bb-b04d-bbfd8a8b11bc",
  ORDER_PREP_INBOX_ID: "96737318-1d9f-45fa-bb4e-0f87ec8fd47e",
  IN_TRANSIT_ID: "7ae258e5-8192-4e63-8733-17ecf002482f",
  IN_TRANSIT_HARD_ID: "0f1ee7cb-1f5b-41c0-9e49-c87a7aee4fea",
  POST_TRANSIT_ID: "e0b5ca67-d1b5-40d3-a717-82fd7f7aa29f",
});
